<template>
  <div id="app3">
      <header>
        <Navbar1/>
      </header>
  </div>
</template>

<script>
import Navbar1 from './components/Navbar1';

export default {
  name: 'App',
  components: {
    Navbar1,
  }
}
</script>
